
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor/founders-letter",
      function () {
        return require("private-next-pages/investor/founders-letter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investor/founders-letter"])
      });
    }
  